import { useQuery } from "@tanstack/react-query";
import ordersClient, { Order } from "../../../api/order";

const useOrderByNameQuery = (orderName: string) => {
  return useQuery({
    queryKey: ["orderByName", orderName],
    queryFn: async () => {
      const orders = (await ordersClient.textSearchOrders({
        query: orderName,
        limit: 10,
      })) as Order[];
      return orders.find((order) => order.orderName === orderName) ?? null;
    },
    enabled: !!orderName,
  });
};

export default useOrderByNameQuery;
